import {createSlice} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {createAsyncThunk} from '@reduxjs/toolkit';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
const initialState = {
  epiContent: '',
  currentStep: '',
  isAllocationsLoaded: false,
  showPopup: false,
  orgFamilyBenefitsAllocations: {},
  benefitsAllocations: {},
  messageData: null,
};

//-----------------------------------------

export const getOrgFamilyBenefitsAllocations = createAsyncThunk(
  'organizationEmployee/getOrgFamilyBenefitsAllocations',
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      const result = await ProviderManager.getProviderData('getOrgFamilyBenefitsAllocations', []);
      thunkAPI.dispatch(hideAppLoader());
      return result.Body;
    } catch (error) {
      thunkAPI.dispatch(hideAppLoader());
      throw error;
    }
  },
);
//-----------------------------------------
const OrgEmployeeFamilySaleSlice = createSlice({
  name: 'orgEmployeeFamilySale',
  initialState,
  reducers: {
    saveToHistory: (state) => {
      return state;
    },
    setMessageData: (state, action) => {
      state.showPopup = true;
      state.messageData = action.payload;
    },
    pushToHistory: (state) => {
      return state;
    },
    clearHistory: () => initialState,
    backHistory: (state) => {
      return state;
    },
    resetState: () => initialState,
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      state.showPopup = false;
    },
    setShowPopup: (state, action) => {
      state.showPopup = action.payload;
    },
    setEpiContent: (state, action) => {
      state.epiContent = action.payload;
    },
  },
  extraReducers: {
    [getOrgFamilyBenefitsAllocations.fulfilled]: (state, action) => {
      state.benefitsAllocations = action.payload.productsDescription || {};
      state.organizationName = action.payload.organizationName;
      state.isAllocationsLoaded = true;
    },
    [getOrgFamilyBenefitsAllocations.rejected]: (state) => {
      state.isAllocationsLoaded = false;
    },
  },
});

export const {
  saveToHistory,
  pushToHistory,
  clearHistory,
  backHistory,
  resetState,
  setCurrentStep,
  setShowPopup,
  setEpiContent,
  setMessageData,
} = OrgEmployeeFamilySaleSlice.actions;

export default OrgEmployeeFamilySaleSlice.reducer;
